import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const SupplierOnlineManagementForm = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;
  /* Child element styles
  ------------------------------- */
  .business-type {
    margin-left: 4px;
    color: ${VARIABLES.COLORS.GRAY_3};
  }

  .step-progress {
    background-color: ${VARIABLES.COLORS.WHITE};
    padding: 27px 24px;
    position: fixed;
    /* top: 440px; */
    bottom: 7rem;
    width: 100%;
    max-width: 316px;
    right: 0;
    border-radius: 6px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;

    &::before {
      display: inline-block;
      content: '';
      position: absolute;
      top: 28px;
      left: 44px;
      width: 2px;
      height: calc(100% - 122px);
      border-left: 2px solid #ccc;
    }

    &-item {
      position: relative;
      counter-increment: list;
      padding-left: 60px;
      min-height: 64px;
      font-size: 14px;
      color: #aaaaaa;

      &:not(:last-child) {
        /* padding-bottom: 20px; */
      }

      &::before {
        display: block;
        content: '';
        position: absolute;
        left: 20px;
        height: 100%;
        width: 2px;
      }

      &::after {
        content: '';
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 40px;
        height: 40px;
        border: 1px solid #ccc;
        border-radius: 50%;
        background-color: #fff;
        content: counter(list);
        color: #ccc;
        font-size: 24px;
        line-height: 1;
        text-align: center;
      }

      &.step-last-done {
        &::before {
          display: none;
        }

        &::after {
          content: counter(list);
          color: #fff;
          text-align: center;
          border: 1px solid #16a651;
          background-color: #16a651;
        }

        div + div {
          color: #16a651;
        }
      }
      &.step-last-current {
        &::before {
          display: none;
        }

        &::after {
          content: counter(list);
          padding-top: 1px;
          width: 40px;
          height: 40px;
          top: 0;
          left: 0;
          color: #4b4acb;
          border: 1px solid #4b4acb;
          background-color: #e3ebf0;
        }

        div + div {
          color: #595959;
        }
      }

      &.is-done {
        &::before {
          border-left: 2px solid #16a651;
        }
        &::after {
          content: counter(list);
          color: #fff;
          text-align: center;
          border: 1px solid #16a651;
          background-color: #16a651;
        }

        div + div {
          color: #16a651;
        }
      }

      &.is-current {
        &::before {
          border-left: 2px solid #4b4acb;
        }

        &::after {
          content: counter(list);
          padding-top: 1px;
          width: 40px;
          height: 40px;
          top: 0;
          left: 0;
          color: #4b4acb;
          border: 1px solid #4b4acb;
          background-color: #e3ebf0;
        }

        div + div {
          color: #595959;
        }
      }
    }

    strong {
      display: block;
    }
  }

  .step-line-wrapper {
    display: flex;
    padding-top: 1rem;
    border-top: 1px solid #ccc;
    display: flex;
    column-gap: 10px;
    align-items: center;

    span {
      color: #16a651;
    }
  }

  .main-content {
    background-color: transparent;
    max-width: 1200px;
    flex-direction: column;
    margin: auto;
    padding-left: 0;
    padding-right: 0;
    align-items: center;
  }

  .btn-download {
    position: absolute;
    width: 200px;
    top: 20px;
    right: 20px;
  }
  .page-topbar {
    align-items: flex-start;
    color: ${VARIABLES.COLORS.GRAY_3};
    font-size: 14px;

    ul {
      display: flex;
      gap: 10px 20px;

      li {
        display: flex;
        column-gap: 10px;
      }

      span:last-child {
        color: ${VARIABLES.COLORS.BLUE_1};
      }
    }

    + .content-body {
      border-top: 4px solid ${VARIABLES.COLORS.BLUE_1};
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      position: relative;
    }
  }

  .content-body {
    background-color: white;
    h2 {
      font-size: 28px;
      margin-bottom: 1rem;
      color: ${VARIABLES.COLORS.BLUE_1};
    }

    sub {
      color: ${VARIABLES.COLORS.GRAY_10};
      font-size: 18px;
    }
  }

  .section-header {
    padding: 24px 24px 0;
    column-gap: 20px;
    font-size: 18px;

    h4 {
      color: ${VARIABLES.COLORS.GRAY_3};
      margin-bottom: 1rem;
    }

    small {
      color: ${VARIABLES.COLORS.GRAY_5};
      font-size: 18px;
    }
  }

  .section-no {
    color: ${VARIABLES.COLORS.BLUE_1};
  }

  .card {
    border: 1px solid ${VARIABLES.COLORS.BLUE_11};
    border-radius: 6px;
    flex-direction: column;
    margin: 24px;
    padding: 24px;
    color: ${VARIABLES.COLORS.GRAY_3};
  }

  .card-title {
    column-gap: 20px;
    padding-bottom: 1rem;
    border-bottom: 1px solid ${VARIABLES.COLORS.BLUE_11};
    color: ${VARIABLES.COLORS.GRAY_3};

    > span {
      color: ${VARIABLES.COLORS.BLUE_1};
    }
  }

  .card-body {
    flex-direction: column;

    ul {
      padding: 24px 28px 0 28px;
    }

    li {
      border-bottom: 1px solid ${VARIABLES.COLORS.GRAY_2};
      padding-left: 60px;
      padding-right: 24px;
      padding-bottom: 24px;
      margin-bottom: 24px;
    }

    .form-group > label {
      justify-content: start;
    }

    .textarea {
      max-width: 100%;
    }
  }

  .sub-heading {
    position: relative;
    display: flex;
    column-gap: 20px;
    color: ${VARIABLES.COLORS.GRAY_3};
    margin-bottom: 1rem;
    justify-content: space-between;

    > span {
      color: ${VARIABLES.COLORS.BLUE_1};
      position: absolute;
      left: -44px;
    }
  }

  .sub-body {
    p {
      color: ${VARIABLES.COLORS.GRAY_10};
      margin-bottom: 1rem;
    }
  }

  .checkbox-group {
    margin-bottom: 1rem;

    .fake-label {
      color: ${VARIABLES.COLORS.GRAY_3};
    }

    .fake-checkbox {
      padding-left: 0;
    }
  }

  .form-group {
    .input-upload-control {
      width: auto;
      min-width: auto;
      flex: 0 0 auto;
    }

    .message {
      padding-left: 0;
    }
  }

  /* Modifiers
  ------------------------------- */

  /* State */
  .is-error {
    .fake-checkbox {
      border-color: ${VARIABLES.COLORS.RED_6};
    }

    > span {
      color: ${VARIABLES.COLORS.RED_6};
    }

    .browse-file {
      background-color: ${VARIABLES.COLORS.RED_6};
    }

    &.message {
      color: ${VARIABLES.COLORS.RED_6};
      font-size: 16px;
    }
  }

  .section-text-error {
    justify-content: flex-end;
  }

  .tooltip-upload {
    .tooltip-attachment {
      position: relative;
      margin-left: 0.5rem;
      right: 0;
    }
  }

  /* Media queries
  ------------------------------- */
  @media (max-width: 1710px) {
    .step-progress {
      max-width: 228px;
    }
  }
  @media (max-width: 1540px) {
    .step-progress {
      max-width: 147px;
      font-size: 10px;
      ::before {
        left: 38px;
      }
      .step-progress-item {
        padding-left: 40px;
        ::before {
          left: 15px;
        }
        ::after {
          font-size: 10px;
          width: 30px;
          height: 30px;
        }
      }
      div {
        font-size: 10px;
      }
    }
  }
`
